export default {
  title: 'Dashboard',
  locales: [
    {
      name: 'en',
      text: 'English',
    },
    {
      name: 'kr',
      text: 'Korean',
    },
  ],
  defaultLocale: 'en',
  iconfont: 'md',
  primaryTheme: 'dark',
  secondaryTheme: 'dark',
  theme: {
    primary: '#AB47BC',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
}
